import { useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { InputText, InputTextType } from 'src/components/atoms/InputText';
import Text, { TextColor, TextVariant } from 'src/components/atoms/Text';

import {
  CALCULATION_NOTE_HINT,
  CALCULATION_NOTE_MAX_LENGTH,
  CALCULATION_NOTE_MIN_LENGTH
} from './constants';

type CalculationNoteFormValues = { calculation_note: string };

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 1rem;
  text-align: left;
`;

const CalculationNoteField = () => {
  const { watch } = useFormContext<CalculationNoteFormValues>();
  const length = (watch('calculation_note') ?? '').trim().length;

  return (
    <Field>
      <Text variant={TextVariant.small} color={TextColor.gray700} isBold>
        Calculation note
        <span aria-hidden="true">
          <Text variant={TextVariant.small} color={TextColor.error} isBold>
            &nbsp;*
          </Text>
        </span>
      </Text>
      <InputText
        name="calculation_note"
        placeholder="Type your note here..."
        type={InputTextType.text}
        showLabel={false}
        showOptionalLabel={false}
        multiline
        rows={4}
        maxLength={CALCULATION_NOTE_MAX_LENGTH}
        config={{ required: 'A calculation note is required' }}
        data-testid="calculation-note-input"
      />
      <Text variant={TextVariant.small} color={TextColor.gray600}>
        {CALCULATION_NOTE_HINT}
      </Text>
      <Text variant={TextVariant.small} color={TextColor.gray600} testId="calculation-note-counter">
        {length < CALCULATION_NOTE_MIN_LENGTH
          ? `${length}/${CALCULATION_NOTE_MIN_LENGTH} characters minimum`
          : `${length} characters`}
      </Text>
    </Field>
  );
};

export default CalculationNoteField;
